export default __webpack_public_path__ + "static/media/arrowRightMoss.ab871345.svg";